import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import {
	createdAtmodifiedAtActions,
	formatDate,
	enumToStringConverter,
} from "../../../helpers/appHelpers";
import { LEAVE_REQUEST_OPTIONS } from "../../../models/leave-request.dto";
import { Avatar } from "@mui/material";

export const LeaveRequestsColumns: GridColDef[] = [
	{
		field: "startDate",
		headerName: "Start Date",
		minWidth: 190,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) =>
			new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params: GridValueGetterParams) => {
			const startDate = formatDate(params);
			return startDate;
		},
	},
	{
		field: "returnDate",
		headerName: "End Date",
		minWidth: 190,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) =>
			new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params: GridValueGetterParams) => {
			const returnDate = formatDate(params);
			return returnDate;
		},
	},
	{
		field: "status",
		headerName: "Status",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		renderCell(params) {
			return (
				<div
					className="rounded-lg px-4 py-2 min-w-[80px] text-center relative font-semibold overflow-hidden"
					style={{ color: getLeaveRequestStatusColor(params.value) }}
				>
					<div
						className="absolute inset-0"
						style={{
							background: getLeaveRequestStatusColor(params.value),
							opacity: "15%",
						}}
					/>
					<p>{enumToStringConverter(params.value)}</p>
				</div>
			);
		},
	},
	{
		field: "comment",
		headerName: "Comment",
		minWidth: 350,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "leavePackage",
		headerName: "Leave Type",
		headerClassName: "super-app-theme--header",
		minWidth: 220,
		flex: 1,
		renderCell(params) {
			const leaveType = params.row.leavePackage?.leaveType;

			return (
				<div
					className="rounded-lg px-4 py-2 min-w-[80px] text-center relative font-semibold overflow-hidden"
					style={{ color: leaveType?.colorCode }}
				>
					<div
						className="absolute inset-0"
						style={{
							background: leaveType?.colorCode,
							opacity: "15%",
						}}
					/>
					<p>{leaveType?.name}</p>
				</div>
			);
		},
	},

	...createdAtmodifiedAtActions,
];

export const SuperviseesLeaveRequestColumns: GridColDef[] = [
	{
		field: "employee",
		headerName: "Employee",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
		renderCell(params) {
			return (
				<div className="flex items-center space-x-4">
					<Avatar
						src={params.value?.photoUrl}
						alt="Dp"
						className="w-10 h-10 rounded-full"
					/>
					<p className="truncate">
						{(params.value?.firstName || "") +
							" " +
							(params.value?.lastName || "")}
					</p>
				</div>
			);
		},
	},

	...LeaveRequestsColumns,
];

export const LeavePlansColumns: GridColDef[] = [
	{
		field: "intendedStartDate",
		headerName: "Intended Start Date",
		minWidth: 230,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) =>
			new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params: GridValueGetterParams) => {
			const startDate = formatDate(params);
			return startDate;
		},
	},
	{
		field: "intendedReturnDate",
		headerName: "Intended End Date",
		minWidth: 230,
		flex: 1,
		headerClassName: "super-app-theme--header",
		sortComparator: (date1, date2) =>
			new Date(date1).getTime() - new Date(date2).getTime(),
		valueGetter: (params: GridValueGetterParams) => {
			const startDate = formatDate(params);
			return startDate;
		},
	},
	{
		field: "comment",
		headerName: "Comment",
		minWidth: 350,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "leavePackage",
		headerName: "Leave Type",
		headerClassName: "super-app-theme--header",
		minWidth: 220,
		flex: 1,
		renderCell(params) {
			const leaveType = params.row.leavePackage?.leaveType;

			return (
				<div
					className="rounded-lg px-4 py-2 min-w-[80px] text-center relative font-semibold overflow-hidden"
					style={{ color: leaveType?.colorCode }}
				>
					<div
						className="absolute inset-0"
						style={{
							background: leaveType?.colorCode,
							opacity: "15%",
						}}
					/>
					<p>{leaveType?.name}</p>
				</div>
			);
		},
	},

	...createdAtmodifiedAtActions,
];

export const SuperviseesLeavePlanColumns: GridColDef[] = [
	{
		field: "employee",
		headerName: "Employee",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
		renderCell(params) {
			return (
				<div className="flex items-center space-x-4">
					<Avatar
						src={params.value?.photoUrl}
						alt="Dp"
						className="w-10 h-10 rounded-full"
					/>
					<p className="truncate">
						{(params.value?.firstName || "") +
							" " +
							(params.value?.lastName || "")}
					</p>
				</div>
			);
		},
	},

	...LeavePlansColumns,
];

export const getLeaveRequestStatusColor = (status: LEAVE_REQUEST_OPTIONS) => {
	switch (status) {
		case "APPROVED":
			return "#4CAF50";
		case "CANCELLED":
			return "#808080";
		case "DECLINED":
			return "#F44336";
		case "PENDING":
			return "#FFC107";
		default:
			return "#2196F3";
	}
};

export function getDaysBetweenDates(startDate, endDate) {
	startDate = new Date(startDate);
	endDate = new Date(endDate);

	const diffInMilliseconds = endDate.getTime() - startDate.getTime();

	const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

	return diffInDays;
}
